import dynamic from "next/dynamic";
const TitleOnlyParagraphComponent = dynamic(()=>import("./title-only-paragraph-component"));
import TitleOnlyParagraphConfig from "./title-only-paragraph-config";
import TitleOnlyParagraphAdvancedConfig from "./title-only-paragraph-advanced-config";
export default {
    TitleOnlyParagraphComponent,
    TitleOnlyParagraphConfig,
    TitleOnlyParagraphAdvancedConfig
};
